module.exports = __webpack_public_path__ + "img/album13_03.3c76879a.jpg";